import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          主题索引
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="flex items-start gap-3 p-4 rounded-lg bg-background-50 hover:bg-primary-50/50 transition-colors cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 mb-0.5 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-1 line-clamp-1">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}